<template>
  <div class="car-reservation-details">
    <div v-if="selectedCar.LotRelocations.length" class="row">
      <div class="col-lg-12">
        <template v-for="relo in selectedCar.LotRelocations">
          <div v-if="relo.permanent" class="callout callout-warning">
            <p>
              This car will be relocated to a different parking bay between
              <strong>{{ new Date(relo.startDate).getTime() - relo.buffer * 60000 | date_format selectedCar.Lot.timezone }}</strong>
              and <strong>{{ new Date(relo.endDate).getTime() + relo.buffer * 60000 | date_format selectedCar.Lot.timezone }}</strong>.
            </p>
            <p>
              From <strong>{{ new Date(relo.endDate).getTime() + relo.buffer * 60000 | date_format selectedCar.Lot.timezone }}</strong>,
              this car will be available to book at
              <a :href="'https://www.google.com/maps/dir/\'' +
              relo.OriginalLot.latitude + ',' + relo.OriginalLot.longitude +
              '\'/' + relo.Lot.latitude + ',' + relo.Lot.longitude +
              '/data=!3m1!4b1!4m7!4m6!1m3!2m2!1d145.0580063!2d-37.7004365!1m0!3e2'"
              target="_blank"><u>{{ relo.Lot.address }}</u></a>.
            </p>
            <p>
              This car was originally located at: <a v-bind:href="'https://www.google.com/maps?q='+ relo.OriginalLot.latitude +','+ relo.OriginalLot.longitude" target="_blank"><u>{{ relo.OriginalLot.address }}</u></a>.
            </p>
          </div>
          <div v-else class="callout callout-info">
            <p>
              This car will be temporarily located at <a :href="'https://www.google.com/maps/dir/\'' +
              relo.OriginalLot.latitude + ',' + relo.OriginalLot.longitude +
              '\'/' + relo.Lot.latitude + ',' + relo.Lot.longitude +
              '/data=!3m1!4b1!4m7!4m6!1m3!2m2!1d145.0580063!2d-37.7004365!1m0!3e2'"
              target="_blank"><u>{{ relo.Lot.address }}</u></a> between
              <strong>{{ relo.startDate | date_format selectedCar.Lot.timezone }}</strong>
              and <strong>{{ relo.endDate | date_format selectedCar.Lot.timezone }}</strong>.
            </p>
            <p>
              From <strong>{{ new Date(relo.endDate).getTime() + relo.buffer * 60000 | date_format selectedCar.Lot.timezone }}</strong> the car will be available to book at it's original bay: <a v-bind:href="'https://www.google.com/maps?q='+ relo.OriginalLot.latitude +','+ relo.OriginalLot.longitude" target="_blank"><u>{{ relo.OriginalLot.address }}</u></a>.
            </p>
          </div>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">Car Details</h1>
          </div>
          <div class="box-body">
            <car-display v-bind:car="selectedCar"></car-display>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">Reserve Car</h1>
          </div>
          <div class="box-body">
            <template v-if="oneWayTrips">
              <label class="label label-black label-margin">
                <span class="fa fa-long-arrow-right fa-lg"></span> OWT
              </label> Car available for one way trip
              <br/><br/>
            </template>
            <template v-if="isMasterAccount">
              <div v-if="searchCriteria.drivers.objects.length > 0">
                <object-select-input v-bind:field.sync="searchCriteria.drivers"></object-select-input>
                <div class="form-section-info" v-if="accountUuid != searchCriteria.drivers.value && searchCriteria.drivers.value">
                  By selecting a driver other than yourself, this booking becomes a business booking and only business credit cards may be used.
                </div>
              </div>
              <br/>
            </template>
            <date-time-range-input v-ref:date-time :field.sync="searchCriteria"></date-time-range-input>
            <br/>
            <price-table :price-breakdown="object" :show-details="false"></price-table>
            <template v-if="conflictingReservations.length > 0">
              <div class="callout callout-danger" v-if="message">{{{ message }}}</div>
              <div class="callout callout-warning" v-if="reloMessage">{{{ reloMessage }}}</div>
            </template>
            <center><button class="btn btn-default btn-lg" v-if="valid" v-on:click="reserveModal()">Reserve</button></center>
          </div>
        </div>
      </div>
      <div class="col-md-5 col-sm-12">
        <car-availability v-ref:availability v-bind:car="selectedCar" v-bind:date="searchCriteria.startDate" v-bind:search="searchCriteria"></car-availability>
      </div>
    </div>
  </div>
  <!-- Reserve Modal -->
  <modal v-if="reserveModalActive" v-el:reserve-modal>
    <template slot="header">
      Confirm Reservation
    </template>
    <template slot="body">
      <div class="form-section-info">
        Please confirm that the below information is correct:
      </div>
      <div class="car-details clearfix">
        <center>
        <img v-bind:src="'https://techcar-dev.s3.amazonaws.com/' +
        selectedCar.CarType.AmazonImage.objectKey"/>
        <p><strong>
          {{ selectedCar.CarType.name }} (#{{ selectedCar.convadisId }}
          - {{ selectedCar.name }})
        </strong></p>
        <p>
          <span class="fa fa-map-marker fa-fw"></span>
          {{ selectedCar.Lot.address }}
        </p>
        </center>
      </div>
      <hr/>
      <template v-if="isMasterAccount">
        <div v-if="searchCriteria.drivers.objects.length > 0">
          <object-select-input v-bind:field.sync="searchCriteria.drivers"></object-select-input>
          <div class="form-section-info" v-if="accountUuid != searchCriteria.drivers.value && searchCriteria.drivers.value">
            By selecting a driver other than yourself, this booking becomes a business booking and only business credit cards may be used.
          </div>
        </div>
        <br/>
      </template>
      <div class="callout callout-success">
        <date-time-range-input v-ref:date-time-modal :field.sync="searchCriteria"></date-time-range-input>
      </div>
      <reservation-promo-input
        v-ref:promo
        :field="object.promo"
        :user="accountUuid"
        :date="searchCriteria"
        :car="object.carUuid">
      </reservation-promo-input>
      <price-breakdown :object.sync="object"></price-breakdown>
      <h4>Memo:</h4>
      <textarea-input :field.sync="memo"></textarea-input>
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="agreement"/>
          <strong>Agreement</strong><span class="required">*</span><br/>
          I agree to the terms and conditions outlined in the
          <a :href="selectedCar.Organization.muaUrl"
           target="_blank">Member User Agreement</a>
        </label>
      </div>
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="driversLicense"/>
          <strong>Driver's License</strong><span class="required">*</span>
          <br/>
          I have a valid driver's license on file
        </label>
      </div>
      <p class="callout callout-warning" v-if="!hasLicense">
        You do not currently have drivers licence on file. Please upload a
         drivers license. To do so,
         <a data-dismiss="modal" v-link="{path: '/my-account?tab=driver-info'}">
           <strong>click here</strong>
         </a>.
      </p>
      <div class="row">
        <div class="col-sm-12">
          <span class="form-validation-error" v-show="!$refs.dateTimeModal.valid">
            <span class="fa fa times"></span>
            You have selected an invalid time for this booking.
          </span>
        </div>
      </div>
    </template>
    <template slot="footer">
      <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
      <button :disabled="!$refs.dateTimeModal.valid" class="btn btn-default" data-dismiss="modal" @click="oneWayTrips ? showOwt() : showExtras()">{{ optionalButtonText }}</button>
    </template>
  </modal>
  <!-- one way trip modal -->
  <template v-if="oneWayTrips">
    <modal v-if="owtModalActive" v-el:owt-modal>
      <template slot="header">
        One Way Trip Options
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-sm-12">
            <strong>ORIGIN</strong><br/>
            <input class="form-control" type="text" :value="selectedCar.Lot.address" readonly />
          </div>
        </div><br/>
        <div class="row" v-if="!differentDestination">
          <div class="col-sm-12">
            <strong>RETURN CAR TO</strong><br/>
            <input class="form-control" type="text" :value="selectedCar.Lot.address" readonly /><br/>
            <button class="btn btn-default" @click="getAvailableLots()">Change Return Address</button>
          </div>
        </div>
        <div class="row" v-if="differentDestination">
          <div class="col-sm-12">
            <strong>RETURN CAR TO</strong><br/>
          </div>
          <object-select-input
            :field.sync="availableLots">
          </object-select-input>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" @click="backToReserve()">Back</button>
        <button class="btn btn-default" data-dismiss="modal" @click="showExtras()">{{ optionalButtonText }}</button>
      </template>
    </modal>
  </template>
  <!-- Extras modal -->
  <template v-if="object.optionalExtras">
    <modal v-if="optionalModalActive" v-el:optional-modal>
      <template slot="header">
        Optional Extra {{ optionalExtraIndex + 1}} of {{ object.optionalExtras.length }}
      </template>
      <template slot="body">
        <div class="checkbox">
          <label>
            <input type="checkbox" @change="updateExtras(object.optionalExtras[optionalExtraIndex])" :checked="checkedExtra"/>
            <strong>Yes, I would like {{ object.optionalExtras[optionalExtraIndex].name }}</strong><br/>
            {{ object.optionalExtras[optionalExtraIndex].description }}
          </label>
        </div>
        <price-table :price-breakdown.sync="object" ></price-table>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" @click="previousExtra()">Back</button>
        <button class="btn btn-default" @click="nextExtra()">{{ optionalButtonText }}</button>
      </template>
    </modal>
  </template>
  <!-- Error Modal -->
  <error-modal v-if="errorModalActive" v-bind:error-message="reservationError"></error-modal>
</div>
</template>

<script>
import CarDisplay from './CarDisplay.vue'
import CarAvailability from './CarAvailability.vue'
import moment from 'moment-timezone'
import PriceBreakdown from '../displays/PriceBreakdown.vue'
import ErrorModal from '../modals/ErrorModal.vue'
import PriceTable from '../displays/PriceTable.vue'
import DateTimeRangeInput from '../inputs/DateTimeRangeInput.vue'
import Modal from '../Modal'
import TextareaInput from '../inputs/TextareaInput.vue'
import ObjectSelectInput from '../inputs/ObjectSelectInput.vue'
import ReservationPromoInput from '../inputs/ReservationPromoInput'

export default {
  name: 'CarReservationDetails',
  components: {
    Modal,
    DateTimeRangeInput,
    CarDisplay,
    CarAvailability,
    PriceBreakdown,
    TextareaInput,
    ErrorModal,
    PriceTable,
    ObjectSelectInput,
    ReservationPromoInput
  },
  data () {
    let minutes = Math.floor(moment().minutes() / 15)
    let now = moment().minutes(minutes * 15).seconds(0)
    let start = now.clone().toDate()
    let end = now.clone().add(1, 'hour').toDate()
    if (this.$route.query.s) {
      start = moment(this.$route.query.s, 'x').toDate()
      end = moment(this.$route.query.e, 'x').toDate()
    }
    return {
      availableLots: {
        value: '',
        objects: [],
        objectName: 'label'
      },
      differentDestination: false,
      owtModalActive: false,
      priceBreakdown: {
        cost: {},
        rate: {}
      },
      optionalModalActive: false,
      optionalExtraIndex: 0,
      object: {
        allowsFinanceCodes: false,
        businessReservation: false,
        businessOnly: false,
        carUuid: '',
        cost: {},
        cards: {
          required: true,
          valid: false,
          dirty: true
        },
        extras: [],
        rate: {},
        reservation: {},
        extraCredit: 0,
        optionalExtras: [],
        financeCode: {
          name: 'financeCode',
          label: 'Finance Code',
          value: '',
          objects: [],
          objectName: 'dropdownLabel',
          valid: false,
          dirty: false,
          required: true
        },
        promo: {
          label: 'Promotional Code',
          name: 'promo',
          value: '',
          dirty: false,
          valid: false,
          required: false
        }
      },
      reserveModalActive: false,
      errorModalActive: false,
      message: false,
      reloMessage: false,
      selectedCar: {
        LotRelocations: [],
        uuid: false,
        name: '',
        convadisId: 0,
        color: '',
        rego: '',
        Reservations: [],
        CarType: {
          AmazonImage: {}
        },
        Lot: {}
      },
      conflictingReservations: [],
      searchCriteria: {
        startDate: start,
        endDate: end,
        minimumMinutes: this.$root.minimumMinutes,
        maximumDays: this.$root.maximumDays,
        drivers: { value: '', objects: [] }
      },
      agreement: false,
      driversLicense: false,
      reservationError: '',
      selectedCard: {},
      memo: {
        dirty: true,
        valid: true,
        name: 'memo',
        value: '',
        height: '100px'
      },
      isMasterAccount: false,
      accountUuid: '',
      hasLicense: true
    }
  },
  ready () {
    this.checkMaster()
    this.getCar()
  },
  events: {
    promoCodeActivated (promoRate) {
      this.updateCost()
    },
    dateTimeChanged () {
      this.differentDestination = false
      if (this.reserveModalActive) {
        this.$refs.promo.validateField()
        this.updateCost()
      } else {
        this.checkConflictingReservations()
        this.$refs.availability.loadAvailability()
      }
      if (this.selectedCar.LotRelocations.length) {
        if (this.selectedCar.LotRelocations[0].permanent) {
          if (moment(this.searchCriteria.startDate).isSameOrAfter(moment(this.selectedCar.LotRelocations[0].endDate))) {
            this.selectedCar.Lot = this.selectedCar.LotRelocations[0].Lot
          } else {
            this.selectedCar.Lot = this.selectedCar.LotRelocations[0].OriginalLot
          }
        } else {
          if (moment(this.searchCriteria.startDate).isSameOrAfter(moment(this.selectedCar.LotRelocations[0].startDate)) &&
          moment(this.searchCriteria.endDate).isSameOrBefore(moment(this.selectedCar.LotRelocations[0].endDate))) {
            this.selectedCar.Lot = this.selectedCar.LotRelocations[0].Lot
          } else {
            this.selectedCar.Lot = this.selectedCar.LotRelocations[0].OriginalLot
          }
        }
      }
    }
  },
  computed: {
    oneWayTrips () {
      if (this.selectedCar.LotRelocations.length === 1) {
        let relo = this.selectedCar.LotRelocations[0]
        if (!relo.permanent) {
          let end = moment(relo.endDate).add(relo.buffer, 'minutes')
          let endDate = moment(this.endTime)
          if (endDate.isAfter(end)) {
            this.selectedCar.LotRelocations = []
          }
        } else {
          let end = moment(relo.endDate).add(relo.buffer, 'minutes')
          let startDate = moment(this.startTime)
          if (startDate.isAfter(end)) {
            this.selectedCar.LotRelocations = []
          }
        }
      }
      return this.selectedCar.oneWayTrips && this.$root.oneWayTrips && this.selectedCar.Lot.oneWayTrips && !this.selectedCar.LotRelocations.length
    },
    valid: function () {
      if (this.$refs.dateTime) {
        if (this.$refs.dateTime.valid && this.conflictingReservations.length === 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    checkedExtra () {
      return this.object.extras.some((val) => val.uuid === this.object.optionalExtras[this.optionalExtraIndex].uuid)
    },
    optionalButtonText () {
      return this.optionalExtraIndex < (this.object.optionalExtras.length - 1) ? 'Next' : 'Confirm Reservation'
    }
  },
  methods: {
    getAvailableLots () {
      this.$http.post(`${this.$route.authType}/available-bays`, {
        carId: this.selectedCar.uuid,
        startDate: this.searchCriteria.startDate,
        endDate: this.searchCriteria.endDate,
        lat: this.selectedCar.Lot.latitude,
        long: this.selectedCar.Lot.longitude
      }).then((response, status, request) => {
        this.availableLots.value = this.selectedCar.Lot.uuid
        this.availableLots.objects = response.data
        this.differentDestination = true
      })
    },
    showOwt () {
      if (!this.agreement) {
        this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
      } else if (!this.driversLicense) {
        this.errorModal('You did not declare that you have a valid driver\'s license')
      } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.reservation.quotedCost > 0) {
        this.errorModal('You have not entered a valid payment method')
      } else {
        this.owtModalActive = true
        this.$nextTick(function () {
          $(this.$els.owtModal).modal()
          $(this.$els.owtModal).on('hidden.bs.modal', () => {
            this.owtModalActive = false
          })
        })
      }
    },
    updateExtras (extra) {
      let exists = this.object.extras.some((val) => val.uuid === extra.uuid)
      if (!exists) {
        this.object.extras.push(extra)
      } else {
        this.object.extras = this.object.extras.filter((val) => val.uuid !== extra.uuid)
      }
      this.updateCost()
    },
    showExtras () {
      if (!this.agreement) {
        this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
      } else if (!this.driversLicense) {
        this.errorModal('You did not declare that you have a valid driver\'s license')
      } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.cost.subTotalCost > 0) {
        this.errorModal('You have not entered a valid payment method')
      } else {
        this.optionalModalActive = true
        this.optionalExtraIndex = 0
        this.$nextTick(function () {
          $(this.$els.optionalModal).modal()
          $(this.$els.optionalModal).on('hidden.bs.modal', () => {
            this.optionalModalActive = false
          })
        })
      }
    },
    nextExtra () {
      if (this.optionalExtraIndex < this.object.optionalExtras.length - 1) {
        this.optionalExtraIndex++
      } else {
        this.reserve()
      }
    },
    backToReserve () {
      $(this.$els.owtModal).modal('hide')
      this.reserveModal(this.selectedCar)
    },
    previousExtra () {
      if (this.optionalExtraIndex !== 0) {
        this.optionalExtraIndex--
      } else {
        $(this.$els.optionalModal).modal('hide')
        if (this.oneWayTrips) {
          this.showOwt()
        } else {
          this.reserveModal(this.selectedCar)
        }
      }
    },
    checkMaster () {
      this.$http.get(`${this.$route.authType}/user/check-master`, {}).then((response, status, request) => {
        this.isMasterAccount = response.data.isMasterAccount
        this.accountUuid = response.data.accountUuid
        this.hasLicense = response.data.hasLicense
        if (this.isMasterAccount) {
          this.$http.get(`${this.$route.authType}/reserve/get-drivers`, {}).then((response, status, request) => {
            this.searchCriteria.drivers = response.data.form
          })
        }
      })
    },
    reserve () {
      if (!this.agreement) {
        this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
      } else if (!this.driversLicense) {
        this.errorModal('You did not declare that you have a valid driver\'s license')
      } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.reservation.quotedCost > 0) {
        this.errorModal('You have not entered a valid payment method')
      } else {
        let authType = this.$route.authType
        let extras = this.object.extras
        let extraCredit = this.object.extraCredit
        let alreadyPaid = this.object.reservation.quotedCost || 0
        let reservation = this.searchCriteria
        let useCredits = true
        if (this.object.businessReservation || this.object.financeCode.value) useCredits = false
        reservation.memo = this.memo.value
        this.$http.post(`${authType}/reserve`, {
          destinationLot: this.availableLots.value || this.selectedCar.Lot.uuid,
          selectedCar: this.selectedCar,
          reservation,
          extras,
          extraCredit,
          alreadyPaid,
          selectedCard: this.selectedCard,
          useCredits,
          financeCode: this.object.financeCode.value,
          promo: this.object.promo.value
        }).then((response, status, request) => {
          this.$route.router.go(`/reserve/confirm/${response.data.resUuid}`)
        }).catch((err) => {
          this.errorModal(err.body)
        })
      }
    },
    getCar () {
      let params = this.$route.params
      let authType = this.$route.authType
      this.$http.get(`${authType}/get-car`, { params }).then((response, status, request) => {
        this.selectedCar = response.data
        this.checkConflictingReservations()
        this.$emit('dateTimeChanged')
      })
    },
    checkConflictingReservations () {
      this.message = false
      this.reloMessage = false
      let authType = this.$route.authType
      this.conflictingReservations = []
      if (this.selectedCar.convadisId !== 0) {
        this.$http.post(`${authType}/reserve/check`, {
          startDate: this.searchCriteria.startDate,
          endDate: this.searchCriteria.endDate,
          carId: this.selectedCar.convadisId
        }).then((response, status, request) => {
          this.conflictingReservations = response.data
          if (Array.isArray(this.conflictingReservations) && this.conflictingReservations.length > 0) {
            if (this.conflictingReservations[0].OriginalLotUuid) {
              let link = `https://www.google.com/maps/dir/'${this.conflictingReservations[0].OriginalLot.latitude},${this.conflictingReservations[0].OriginalLot.longitude}'/${this.conflictingReservations[0].Lot.latitude},${this.conflictingReservations[0].Lot.longitude}/data=!3m1!4b1!4m7!4m6!1m3!2m2!1d145.0580063!2d-37.7004365!1m0!3e2`
              this.reloMessage = `This car is being moved to a new lot during your selected time. It will be available again at <strong>${moment(this.conflictingReservations[0].endDate).format('LLLL')}</strong> at <a href="${link}" target="_blank"><u>${this.conflictingReservations[0].Lot.address}</u></a>.`
            } else {
              if (moment(this.conflictingReservations[0].blockedStartDate).isBetween(moment(this.searchCriteria.startDate), moment(this.searchCriteria.endDate))) {
                this.message = `The time you have selected is not available for this car. <br/> It is only available until <strong>${moment(this.conflictingReservations[0].blockedStartDate).format('LLLL')}</strong> but will
                be available again at <strong>${moment(this.conflictingReservations[0].blockedEndDate).format('LLLL')}</strong>`
              } else {
                this.message = `The time you have selected is not available for this car. <br/> It will be available again at <strong>${moment(this.conflictingReservations[0].blockedEndDate).format('LLLL')}</strong>`
              }
            }
          } else {
            this.message = response.data
          }
          this.updateCost()
        }).catch(err => {
          this.message = err.body
        })
      }
    },
    updateCost () {
      let authType = this.$route.authType
      let extras = this.object.extras
      let useCredits = true
      if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
      if (this.selectedCar.uuid) {
        this.$http.post(`${authType}/update-cost`, {
          accountUuid: this.accountUuid,
          carUuid: this.selectedCar.uuid,
          lotUuid: this.selectedCar.Lot.uuid,
          startDate: this.searchCriteria.startDate,
          endDate: this.searchCriteria.endDate,
          extras,
          useCredits,
          extraCredit: 0,
          alreadyPaid: 0,
          promo: this.object.promo.value
        }).then((response, status, request) => {
          this.object.allowsFinanceCodes = response.data.hasFinanceCodes
          if (response.data.hasFinanceCodes) {
            this.object.financeCode.objects = response.data.financeCodes
          }
          this.object.cost = response.data.cost
          this.object.rate = response.data.rate.rate
          this.object.optionalExtras = response.data.rate.extras
          this.object.extras = response.data.extras
        })
      }
    },
    reserveModal () {
      let authType = this.$route.authType
      let startDate = moment(this.searchCriteria.startDate).valueOf()
      let endDate = moment(this.searchCriteria.endDate).valueOf()
      let carUuid = this.selectedCar.uuid
      let useCredits = true
      if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
      this.$http.post(`${authType}/reserve/costs`, {
        accountUuid: this.accountUuid,
        carUuid,
        useCredits,
        lotUuid: this.selectedCar.Lot.uuid,
        startDate,
        endDate,
        extras: [],
        extraCredit: 0,
        alreadyPaid: 0,
        businessOnly: this.object.businessOnly,
        promo: this.object.promo.value
      }).then((response, status, request) => {
        if (response.data.costs) {
          this.object.cost = response.data.costs.cost
          this.object.rate = response.data.costs.rate.rate
          this.object.optionalExtras = response.data.costs.rate.extras
          this.object.allowsFinanceCodes = response.data.financeCodes
          this.object.cards = response.data.cards
          this.object.carUuid = carUuid
          this.reserveModalActive = true
          this.$nextTick(function () {
            this.$broadcast('getReservationInfo')
            $(this.$els.reserveModal).modal()
            $(this.$els.reserveModal).on('hidden.bs.modal', () => {
              this.reserveModalActive = false
            })
          })
        } else {
          this.errorModal(response.body)
        }
      }).catch((err) => {
        this.errorModal(err.body || err.toString())
      })
    },
    errorModal (error) {
      this.reservationError = error
      this.errorModalActive = true
      this.$nextTick(function () {
        $('#errorModal').modal()
        $('#errorModal').on('hidden.bs.modal', () => {
          this.errorModalActive = false
        })
      })
    }
  },
  watch: {
    'object.cards.value': function (newVal, oldVal) {
      this.object.cards.objects.forEach(card => {
        if (card.uuid === this.object.cards.value) {
          this.selectedCard = card
          if (card.cardType === 'Business') {
            this.object.businessReservation = true
          } else {
            this.object.businessReservation = false
          }
        }
      })
      this.updateCost()
    },
    'searchCriteria.drivers.value': function (newVal, oldVal) {
      this.object.driverUuid = this.searchCriteria.drivers.value
      this.$broadcast('getReservationInfo')
      let check = false
      if (this.object.businessOnly) {
        check = true
      }
      if (this.accountUuid !== this.searchCriteria.drivers.value) {
        this.object.businessOnly = true
      } else {
        this.object.businessOnly = false
      }
      if (this.object.businessOnly !== check && this.reserveModalActive) {
        this.object.cards.objects = []
        let startDate = moment(this.searchCriteria.startDate).valueOf()
        let endDate = moment(this.searchCriteria.endDate).valueOf()
        let carUuid = this.selectedCar.uuid
        let authType = this.$route.authType
        let useCredits = true
        if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
        this.$http.post(`${authType}/reserve/costs`, {
          accountUuid: this.driverUuid,
          carUuid,
          startDate,
          endDate,
          useCredits,
          extras: [],
          extraCredit: 0,
          alreadyPaid: 0,
          createdAt: null,
          businessOnly: this.object.businessOnly,
          promo: this.object.promo.value
        }).then((response, status, request) => {
          this.object.cards = response.data.cards
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CarReservationDetails.vue?5302b1d7